import { DefaultCard, useDefaultCardStyles } from "../components/default-card";
import { useStyles } from "../card-boleto/card-boleto-styles";
import { Grid, Typography } from '@material-ui/core'
import { useStyles as useHistoricoStyles } from './card-historico-transferencia-styles'
import { EnumStatusBoleto } from "model/enums/enum-status-boleto";
import { TransferenciaHistoricoModel } from "model/api/gestao/transferencia/transferencia-historico-model";
import { toDateString } from "utils/to-date";
import { TpStatusTransferenciaMock } from "data/mocks/tp-status-mock";
import { TpEventoMock } from "data/mocks/tp-evento-mock";
import { OcorrenciaRetornoMock } from "data/mocks/ocorrencia-retorno-mock";
import { MotivoRejeicaoMock } from "data/mocks/motivo-rejeicao-mock";

interface CardHistoricoBoletoProps {
    model: TransferenciaHistoricoModel;
    existeAlgumaOcorrenciaRetorno: boolean;
    existeAlgumaRejeicao: boolean;
}

export const CardHistoricoTransferencia = ({
    model,
    existeAlgumaOcorrenciaRetorno,
    existeAlgumaRejeicao
}: CardHistoricoBoletoProps) => {
    const classes = useDefaultCardStyles({});
    const cardClasses = useStyles({
        status: EnumStatusBoleto.Aceito
    });
    const historicoClasses = useHistoricoStyles();
    const ocorrenciaRetornoCodigo = Number(model.ocorrenciaRetorno);
    const motivoRejeicaoCodigo = Number(model.codigoMotivoRejeicao);

    const neitherExtra = !existeAlgumaOcorrenciaRetorno && !existeAlgumaRejeicao;
    const mdBase = neitherExtra ? 3 : 2;
    const mdOcorrencia = existeAlgumaOcorrenciaRetorno && existeAlgumaRejeicao ? 2 : 3;

    return (
        <>
            <DefaultCard>
                <div className={`${classes.cardContent} ${cardClasses.container} ${historicoClasses.cardHistorico}`}>
                    <Grid container spacing={2}>
                        <Grid item md={mdBase} xs={6}>
                            <Typography color="textSecondary" variant="caption" className={historicoClasses.mobileLabel}>
                                Data
                            </Typography>
                            <Typography
                                color="textPrimary"
                                variant="body1"
                            >
                                {toDateString(model.dataOcorrencia, 'DD/MM/yyyy HH:mm:ss')}
                            </Typography>
                        </Grid>
                        <Grid item md={mdBase} xs={6}>
                            <Typography color="textSecondary" variant="caption" className={historicoClasses.mobileLabel}>
                                Status
                            </Typography>
                            <Typography
                                color="textPrimary"
                                variant="body1"
                            >
                                {TpStatusTransferenciaMock.find(x => x.Key === model.tpStatus)?.Value || 'Sem Status'}
                            </Typography>
                        </Grid>
                        <Grid item md={mdBase} xs={6}>
                            <Typography color="textSecondary" variant="caption" className={historicoClasses.mobileLabel}>
                                Evento
                            </Typography>
                            <Typography
                                color="textPrimary"
                                variant="body1"
                            >
                                {TpEventoMock.find(x => x.Key === model.tpEvento)?.Value || 'Sem Status'}
                            </Typography>
                        </Grid>
                        {model.ocorrencia && (
                            <Grid item md={mdOcorrencia} xs={6}>
                                <Typography color="textSecondary" variant="caption" className={historicoClasses.mobileLabel}>
                                    Ocorrência
                                </Typography>
                                <Typography
                                    color="textPrimary"
                                    variant="body1"
                                    className={historicoClasses.textBreak}
                                >
                                    {model.ocorrencia}
                                </Typography>
                            </Grid>
                        )}
                        {existeAlgumaOcorrenciaRetorno && (
                            <Grid item md={2} xs={6}>
                                <Typography color="textSecondary" variant="caption" className={historicoClasses.mobileLabel} >
                                    Ocorrência Retorno
                                </Typography>
                                <Typography
                                    color="textPrimary"
                                    variant="body1"
                                >
                                    {model.ocorrenciaRetorno
                                        ? `${model.ocorrenciaRetorno} - ${OcorrenciaRetornoMock.find(x => Number(x.Key) === ocorrenciaRetornoCodigo)?.Value || '-'}`
                                        : '-'}
                                </Typography>
                            </Grid>
                        )}
                        {existeAlgumaRejeicao && (
                            <Grid item md={2} xs={6}>
                                <Typography color="textSecondary" variant="caption" className={historicoClasses.mobileLabel}>
                                    Motivo Rejeição
                                </Typography>
                                <Typography
                                    color="textPrimary"
                                    variant="body1"
                                >
                                    {motivoRejeicaoCodigo > 0
                                        ? `${model.codigoMotivoRejeicao} - ${MotivoRejeicaoMock.find(x => Number(x.Key) === motivoRejeicaoCodigo)?.Value || model.descricaoMotivoRejeicao || '-'}`
                                        : '-'}
                                </Typography>
                            </Grid>
                        )}
                    </Grid>
                </div>
            </DefaultCard >
        </>
    );
};